// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"612":"2389ceaf","870":"2389ceaf"}[chunkId] + ".chunk.css";
};